import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  Checkbox,
  Divider,
  Chip,
} from "@mui/material";
import UndoIcon from "@mui/icons-material/Undo";

import { useDesaplicarImputaciones } from "../hook/useDesaplicarImputaciones";

const DesaplicarImputacionModal = ({
  open,
  onClose,
  idRecibo,
  showToast,
  getDocuments,
}) => {
  const { data, selectedIds, loading, toggle, submit } =
    useDesaplicarImputaciones({
      open,
      idRecibo,
      showToast,
      getDocuments,
    });

  const totalSeleccionado = data
    .filter((x) => selectedIds.includes(x.id))
    .reduce((acc, x) => acc + Number(x.importe), 0);

  const totalGeneral = data.reduce((acc, x) => acc + Number(x.importe), 0);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      {/* HEADER */}
      <DialogTitle sx={{ bgcolor: "warning.main", color: "white", py: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" alignItems="center" gap={2}>
            <UndoIcon sx={{ fontSize: 32 }} />
            <Box>
              <Typography variant="h6" fontWeight="bold">
                DESHACER APLICACIONES
              </Typography>
              <Typography variant="subtitle2">Recibo ID: {idRecibo}</Typography>
            </Box>
          </Box>

          <Chip
            label={`${selectedIds.length} seleccionadas`}
            sx={{
              bgcolor: "white",
              color: "warning.main",
              fontWeight: "bold",
            }}
          />
        </Box>
      </DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        {/* INFO */}
        <Paper sx={{ p: 2, bgcolor: "grey.50" }} elevation={0}>
          <Typography variant="body2">
            Seleccioná las aplicaciones que querés desaplicar.
          </Typography>
        </Paper>

        <Divider />

        {/* TABLA */}
        <Box sx={{ p: 3 }}>
          {data.length === 0 ? (
            <Typography>No hay aplicaciones</Typography>
          ) : (
            <Box
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                overflow: "hidden",
              }}
            >
              {/* TABLA SCROLL */}
              <Box sx={{ maxHeight: 350, overflowY: "auto" }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell />
                      <TableCell>Comprobante</TableCell>
                      <TableCell>Nro</TableCell>
                      <TableCell align="right">Importe</TableCell>
                      <TableCell>Fecha</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {data.map((item) => {
                      const isSelected = selectedIds.includes(item.id);

                      return (
                        <TableRow
                          key={item.id}
                          sx={{
                            bgcolor: isSelected ? "warning.50" : "inherit",
                            transition: "all 0.2s",
                            "&:hover": {
                              bgcolor: isSelected
                                ? "warning.100"
                                : "rgba(0,0,0,0.04)",
                            },
                          }}
                        >
                          <TableCell>
                            <Checkbox
                              checked={isSelected}
                              onChange={() => toggle(item.id)}
                            />
                          </TableCell>

                          <TableCell>{item.comprobante}</TableCell>

                          <TableCell>{item.nro_factura}</TableCell>

                          <TableCell align="right">
                            <Typography fontWeight={600}>
                              ${Number(item.importe).toLocaleString("es-AR")}
                            </Typography>
                          </TableCell>

                          <TableCell>
                            {new Date(item.fecha_imputacion).toLocaleDateString(
                              "es-AR",
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </Box>

              {/* 🔥 FOOTER STICKY */}
              <Box
                sx={{
                  position: "sticky",
                  bottom: 0,
                  bgcolor: "white",
                  borderTop: "1px solid #e0e0e0",
                  boxShadow: "0 -2px 8px rgba(0,0,0,0.08)",
                  zIndex: 2,
                }}
              >
                <Table>
                  <TableBody>
                    <TableRow sx={{ bgcolor: "grey.100" }}>
                      <TableCell colSpan={3}>
                        <Typography fontWeight={700}>TOTAL IMPUTADO</Typography>
                      </TableCell>

                      <TableCell align="right">
                        <Typography fontWeight={700}>
                          ${totalGeneral.toLocaleString("es-AR")}
                        </Typography>
                      </TableCell>

                      <TableCell />
                    </TableRow>

                    <TableRow sx={{ bgcolor: "warning.50" }}>
                      <TableCell colSpan={3}>
                        <Typography fontWeight={700}>A DESAPLICAR</Typography>
                      </TableCell>

                      <TableCell align="right">
                        <Typography
                          fontWeight={800}
                          sx={{ color: "warning.main" }}
                        >
                          ${totalSeleccionado.toLocaleString("es-AR")}
                        </Typography>
                      </TableCell>

                      <TableCell />
                    </TableRow>
                  </TableBody>
                </Table>
              </Box>
            </Box>
          )}
        </Box>
      </DialogContent>

      {/* ACTIONS */}
      <DialogActions sx={{ px: 3, py: 2, bgcolor: "grey.50" }}>
        <Button onClick={onClose}>Cancelar</Button>

        <Button
          variant="contained"
          color="warning"
          onClick={submit}
          disabled={loading || selectedIds.length === 0}
        >
          Desaplicar seleccionadas
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DesaplicarImputacionModal;
